export default function SignInPrompt({ title, message, onSignIn, className = "px-6 py-10" }) {
    return (
        <div className={`flex h-full w-full flex-col items-center justify-center rounded-2xl bg-primary-50 text-center ${className}`}>
            <svg className="mb-3 h-8 w-8 text-primary-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            <p className="font-Mulish text-lg font-semibold text-secondary">{title}</p>
            {message ? (
                <p className="mt-1 max-w-sm font-Mulish text-sm text-graphite">{message}</p>
            ) : null}
            <button
                type="button"
                onClick={onSignIn}
                className="mt-4 rounded-full bg-primary-700 px-4 py-2.5 font-Mulish text-sm font-semibold text-white shadow-[0_12px_28px_-10px_rgba(190,49,32,0.65)]"
            >
                Sign in
            </button>
        </div>
    );
}
